export default __webpack_public_path__ + "static/BPA Birchington-8a6faed4b938a238dbe2b67f19ff5fa2.png";